export default __webpack_public_path__ + "images/390487d4219efbba6b438383a1710e75-spirituality.png";